// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"49c189ca","500":"3602f301","671":"179ca98c","752":"b76a3494"}[chunkId] + ".chunk.css";
};